import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import ReactPaginate from 'react-paginate'

import Loader from './Loader'

import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../shared/vars'

import '../../css/pagination.css'
import '../../css/searchbar.css'

class SearchbarAjax extends Component {
    constructor(props) {
        super(props)

        const pg = this.props.pg

        this.state = {
            isLoading: false,
            errors: null,
            data: null,
            q: '',
            pageCount: 8,
            page: pg ? parseInt(pg, 0) - 1 : 0
        }
    }

    componentDidMount() {
        if (!!this.props.onRef) this.props.onRef(this)
        this.search()
    }

    componentWillUnmount() {
        if (!!this.props.onRef) this.props.onRef(undefined)
    }

    search() {

        this.setState({ isLoading: true })

        const apiEndpoint = this.props.searchEndpoint
        const params = {
            q: this.state.q,
            pg: this.state.page + 1,
            access_type: this.props.userType === 'admin' ? 'admin' : 'user'
        }

        if (!!this.props.params) {
            Object.keys(this.props.params).forEach(key => {
                params[key] = this.props.params[key]
            })
        }

        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + this.props.user.token }
        return axios.get(REACT_APP_API_URL + apiEndpoint, { headers: AUTH_HEADER, params: params })
            .then((response) => {
                if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
                    this.setState({ isLoading: false, error: response.data.message })
                } else {
                    this.setState({ isLoading: false, data: { items: response.data[this.props.itemsIndex], ...response.data } })
                }
            })
            .catch((err) => {
                this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message })
            })
    }

    handlePaginationChange(data) {
        const selected = data.selected
        this.setState({ page: selected }, this.search)
    }

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.setState({ page: 0 })
            this.search()
        }
    }

    handleInputChange(e) {
        this.setState({
            q: e.target.value
        })
    }

    renderTable() {
        // Component passed in that displays search results
        const startPosition = this.state.data ? (this.state.data.items_per_page * (this.state.data.current_page - 1)) : 0
        const SearchTable = this.props.component

        return <div className="search-listing">
            <SearchTable items={this.state.data.items} startPosition={startPosition} {...this.props} />
        </div>
    }

    render() {
        return (
            <div>
                <div className="listing padded-listing">
                    <div className="input-wrapper">
                        <input type="text" name="search"
                            placeholder={this.props.placeholder ? this.props.placeholder : 'Search'}
                            value={this.state.q}
                            onKeyPress={e => this.handleKeyPress(e)}
                            onChange={e => this.handleInputChange(e)}
                            disabled={this.props.disabled}
                        />
                        <button className="search-btn icon-search" disabled={this.props.disabled} onClick={() => this.search()}></button>
                    </div>
                </div>

                {this.props.content &&
                    <div>{this.props.content}</div>
                }

                {this.state.isLoading ? (
                    <Loader />
                ) : (
                        // Show errors
                        this.state.errors ? (
                            <div className="error">
                                {Object.keys(this.state.error).map(key =>
                                    <span key={key}>{this.state.error[key]}</span>
                                )}
                            </div>

                            // Show search results
                        ) : (
                                this.state.data !== null && (
                                    this.state.data.total_pages > 1 && !this.props.disabled ? (
                                        <div>
                                            <ReactPaginate
                                                previousLabel={""}
                                                previousLinkClassName={"icon-previous"}
                                                nextLabel={""}
                                                nextLinkClassName={"icon-next"}
                                                breakLabel={<a href="">...</a>}
                                                breakClassName={"break-me"}
                                                pageCount={this.state.data.total_pages}
                                                disableInitialCallback={true}
                                                initialPage={this.state.page}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={4}
                                                onPageChange={this.handlePaginationChange.bind(this)}
                                                containerClassName={"pagination"}
                                                subContainerClassName={"pages pagination"}
                                                activeClassName={"active"}
                                            />
                                            {this.renderTable()}
                                        </div>
                                    ) : (
                                            this.renderTable()
                                        )
                                )
                            )
                    )}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user[ownProps.userType]
    }
}

export default connect(mapStateToProps)(SearchbarAjax)



// WEBPACK FOOTER //
// ./src/components/utils/SearchbarAjax.js